import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Select from "../../../form/select/Select";
import MultiSelect from "../../../form/select/MultiSelect";
import moment from "moment/moment";

export const filterSpecificOffice = (offices, applied_offices) => {
  return offices
    ?.filter((item, i) =>
      applied_offices?.some(
        (office) => item?.id === parseInt(office?.office_id)
      )
    )
    .map((value) => ({
      label: value?.office_name,
      value: value.id,
    }));
};

const Settings = ({
  policy,
  edit,
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  getFieldProps,
  setFieldTouched,
}) => {
  const { offices: { offices } } = useSelector((state) => state?.office);
  // const { unpaginated_charges } = useSelector((state) => state?.charges);

  const rabRef = useRef();
  const subOfficeRef = useRef(null);
  const soRef = useRef(null);

  useEffect(() => {
    // controls the switching of the radio buttons on settings tab.
    // Also clearing of fields previously selected but later unselected
    if (values?.apply_to === "RAB") {
      setFieldTouched("specific_offices", false);
      setFieldValue(
        "region_area_branch",
        policy?.p_settings?.region_area_branch === "nil" ? "" : policy?.p_settings?.region_area_branch
      );
      setFieldValue(
        "apply_to_sub_offices",
        policy?.p_settings?.apply_to_sub_offices
      );
      setFieldValue(
        "specific_offices",
        filterSpecificOffice(offices, values.applied_offices)
      );
      setFieldValue("company_wide", policy?.p_settings?.company_wide);
    } else if (values?.apply_to === "CW") {
      setFieldTouched("region_area_branch", false);
      setFieldValue("region_area_branch", policy?.p_settings?.region_area_branch);
      if (values?.apply_to_sub_offices) {
        subOfficeRef?.current?.click();
      }
      setFieldValue(
        "apply_to_sub_offices",
        policy?.p_settings?.apply_to_sub_offices
      );
      setFieldValue(
        "specific_offices",
        filterSpecificOffice(offices, values.applied_offices)
      );
      setFieldTouched("specific_offices", false);
      setFieldValue("company_wide", 1);
    } else {
      setFieldTouched("region_area_branch", false);
      setFieldValue("region_area_branch", policy?.p_settings?.region_area_branch);

      setFieldValue(
        "apply_to_sub_offices",
        policy?.p_settings?.apply_to_sub_offices
      );
      if (values?.apply_to_sub_offices) {
        subOfficeRef?.current?.click();
      }
      setFieldValue("company_wide", policy?.p_settings?.company_wide);
    }
  }, [values?.apply_to]);


  return (
    <>
      {!edit ? (
        <div>
            <div className=''>
                <b className='mt-3 fw-bolder text-primary-1'>APPLIED OFFICES</b>
                {parseInt(policy?.settings?.company_wide) === 1 && (
                <p>Company Wide</p>
                )}
                {policy?.specific_offices?.length ? (
                <div className='mb-1'>
                    <strong className='mt-2'>Specific Offices: </strong>
                    <div>
                    {filterSpecificOffice(offices, policy?.specific_offices).map(
                        (item, i) => (
                        <span
                            className='bg-primary text-light fs-6'
                            style={{ padding: "4px", margin: "0px 4px" }}
                            key={i}
                        >
                            {item.label}
                        </span>
                        )
                    )}
                    </div>
                </div>
                ) : null}
                {policy?.settings?.region_area_branch !== null && policy?.settings?.region_area_branch !== 0 ? (
                <>
                    <div className='mb-1'>
                    <strong>Region/Area/Branch: </strong>
                    <span>
                        {offices
                        ?.filter(
                            (item) =>
                            parseInt(item?.id) ===
                            parseInt(policy?.settings?.region_area_branch)
                        )
                        ?.map((item, i) => (
                            <span key={i}>{item.office_name}</span>
                        ))}
                    </span>
                    </div>
                    <div className='mb-1'>
                    <strong>Apply to Sub-offfices: </strong>
                    <span>
                        {policy?.settings?.sub_offices === 1
                        ? "Yes"
                        : "No"}
                    </span>
                    </div>
                </>
                ) : null}
            </div>
            {/* <div>
              <h5 className='mt-3 fw-bolder text-primary-1'>Charges</h5>
              <div className='row'>
              <div className='col-md-12'>
                  <div className='charges'>
                  {values?.charges?.length ? (
                      values?.charges?.map((item, i) => {                      
                      return (
                      <span
                          className='bg-primary text-light fs-6'
                          style={{ padding: "4px", margin: "0px 4px" }}
                          key={i}
                      >
                          {item?.charge_name}
                      </span>
                      )})
                  ) : (
                      <p className='alert alert-warning '>
                      No charges selected
                      </p>
                  )}
                  </div>
              </div>
              </div>
            </div> */}
            <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Partial Withdrawal</h5>
                <div className='row'>
                    <div className='col-md-6 mb-2'>
                        <label htmlFor='' className='form-labe mt-1'>
                        Max withdrawal limit before maturity(%)
                        </label>
                        <p>{policy?.partial_withdrawal?.max_withdrawal_limit_before_maturity}</p>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label htmlFor='' className='form-labe mt-1'>
                        Withdrawal Penalty(%)
                        </label>
                        <p>{policy?.partial_withdrawal?.withdrawal_penalty}</p>
                    </div>
                    <div className='mb-1'>
                        <strong>Restrict withdrawal in the absence of savings activity until maturity: </strong>
                        <span>{values?.restrict_withdrawal ? "Yes" : "No"}</span>
                    </div>
                </div>
            </div>
            <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Termination</h5>
                <div className='row'>
                    <div className='col-md-6 mb-2'>
                        <label htmlFor='' className='form-labe mt-1'>
                        Penalty period (max.  in months)
                        </label>
                        <p>{policy?.termination?.penalty_period}</p>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label htmlFor='' className='form-labe mt-1'>
                        Penalty Value (%)
                        </label>
                        <p>{policy?.termination?.penalty_value}</p>
                    </div>
                </div>
            </div>
            <div>
                <div className='row'>
                    <div className='col-md-6 mb-2'>
                        <label htmlFor='' className='form-labe mt-1'>
                        Cool off period (max.  in days)
                        </label>
                        <p>{policy?.cool_off?.cool_off_period}</p>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label htmlFor='' className='form-labe mt-1'>
                        Cool off Penalty (%)
                        </label>
                        <p>{policy?.cool_off?.cool_off_value}</p>
                    </div>
                </div>
            </div>
          {policy?.settings?.expires_at && (
            <div className='row'>
              <h5 className='mt-3 fw-bolder text-primary-1'>EXPIRING DATE</h5>
              <span>
                {moment(policy?.settings?.expires_at).format("LL")}
              </span>
            </div>
          )}
        </div>
      ) : (
        <div className=''>
          <h5>Apply to (Office)</h5>
          <div className='form-check my-3'>
            <input
              className='form-check-input me-2'
              type='radio'
              name='apply_to'
              id='apply_to'
              value='CW'
              onChange={(values) => {
                handleChange(values);
                setFieldValue("company_wide", 1);
              }}
              defaultChecked={values.apply_to === "CW"}
            />
            <label className='form-check-label' htmlFor='company_wide'>
              Company wide
            </label>
          </div>
          <div className='form-check'>
            <input
              className='form-check-input me-2'
              type='radio'
              name='apply_to'
              value='RAB'
              defaultChecked={values.apply_to === "RAB"}
              onChange={handleChange}
              id='apply_to'
            />
            <label className='form-check-label' htmlFor='rab'>
              Region/Area/Branch
            </label>
            {values?.apply_to === "RAB" && (
              <div>
                <Select
                  isError={errors?.region_area_branch && touched?.region_area_branch}
                  name='region_area_branch'
                  ref={rabRef}
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  defaultValue={values?.region_area_branch}
                  onChange={(selectedOption) =>
                    setFieldValue("region_area_branch", selectedOption?.value)
                  }
                  onBlur={() => {
                    handleBlur({ target: { name: "region_area_branch" } });
                  }}
                />
                {errors?.region_area_branch && touched?.region_area_branch && (
                  <p className='text-danger mb-0'>{errors?.region_area_branch}</p>
                )}
                <div className='form-check mt-1'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    value={values?.sub_offices}
                    id='sub_offices'
                    name='sub_offices'
                    onChange={(e) =>
                      setFieldValue("sub_offices", e.target.checked)
                    }
                    defaultChecked={values.sub_offices}
                    ref={subOfficeRef}
                  />
                  <label className='form-check-label' htmlFor=''>
                    Apply to sub offices
                  </label>
                </div>
              </div>
            )}
          </div>
          <div className='form-check mt-3'>
            <input
              className='form-check-input me-2'
              type='radio'
              name='apply_to'
              value='SO'
              onChange={handleChange}
              id='apply_to'
              defaultChecked={values?.apply_to === "SO"}
            />
            <label className='form-check-label ' htmlFor='so'>
              Specific Office(s)
            </label>
            {values?.apply_to === "SO" && (
              <div>
                <MultiSelect
                  isError={
                    errors?.specific_offices && touched?.specific_offices
                  }
                  name='specific_offices'
                  field={{ ...getFieldProps("specific_offices") }}
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  defaultValue={filterSpecificOffice(
                    offices,
                    values.applied_offices
                  )}
                  onChange={setFieldValue}
                  onBlur={() => {
                    handleBlur({ target: { name: "specific_offices" } });
                  }}
                  errors={errors}
                  touched={touched}
                  disabled={values?.apply_to !== "SO"}
                  ref={soRef}
                />
              </div>
            )}
          </div>
          {/* <div className='form-check mt-3'>
            <label className='form-check-label ' htmlFor='so'>
              Add charges
            </label>
            <div>
              <MultiSelect
                isError={errors?.charges && touched?.charges}
                name='charges'
                field={{ ...getFieldProps("charges") }}
                data={unpaginated_charges?.get_savings_charge?.map((item) => ({
                  label: item.charge_name,
                  value: item.id,
                }))}
                defaultValue={values?.charges?.map(item => ({value: item?.id, label: item?.charge_name}))}
                onChange={setFieldValue}
                onBlur={() => {
                  handleBlur({ target: { name: "charges" } });
                }}
                errors={errors}
                touched={touched}
                // ref={soRef}
              />
            </div>
          </div> */}
          <div className='form-check mt-3 mb-4'>
            <label className='form-check-label ' htmlFor='so'>
              Expires at
            </label>
            <div>
              <input
                name='expires_at'
                value={values?.expires_at}
                className='form-control'
                type='date'
                onChange={handleChange}
              />
            </div>
          </div>
          <div className='border p-3 rounded-3 my-4 position-relative' >
                <h4 className='fw-semibold bg-white position-absolute profile-title'>
                    Partial Withdrawal
                </h4>
                <div className="row">
                    <div className='col-md-4 mb-3'>
                        <label htmlFor='default_rate'>
                            Max withdrawal limit before maturity(%)<span className='text-danger'>*</span>
                        </label>
                        <input
                            type='text'
                            className={`form-control ${
                                errors?.max_withdrawal_limit &&
                                touched?.max_withdrawal_limit &&
                                "is-invalid"
                            }`}
                            name='max_withdrawal_limit'
                            id='max_withdrawal_limit'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.max_withdrawal_limit}
                            placeholder='%'
                        />
                        {errors?.max_withdrawal_limit && touched?.max_withdrawal_limit && (
                        <span className='text-danger'>{errors?.max_withdrawal_limit}</span>
                        )}
                    </div>
                    <div className='col-md-4 mb-3'>
                        <label htmlFor='default_rate'>
                        Withdrawal Penalty(%)<span className='text-danger'>*</span>
                        </label>
                        <input
                        type='text'
                        className={`form-control ${
                            errors?.withdrawal_penalty &&
                            touched?.withdrawal_penalty &&
                            "is-invalid"
                        }`}
                        name='withdrawal_penalty'
                        id='withdrawal_penalty'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='%'
                        value={values.withdrawal_penalty}
                        />
                        {errors?.withdrawal_penalty && touched?.withdrawal_penalty && (
                        <span className='text-danger'>{errors?.withdrawal_penalty}</span>
                        )}
                    </div>
                    <div class='form-check mt-1'>
                        <input
                            class='form-check-input'
                            type='checkbox'
                            value={values?.restrict_withdrawal}
                            id='restrict_withdrawal'
                            name='restrict_withdrawal'
                            onChange={handleChange}
                            defaultChecked={values?.restrict_withdrawal}
                        />
                        <label class='form-check-label' for=''>
                            Restrict withdrawal in the absence of savings activity until maturity.  
                        </label>
                    </div>
                </div>
            </div>
            <div className='border p-3 rounded-3 my-4 position-relative' >
                <h4 className='fw-semibold bg-white position-absolute profile-title'>
                    Termination
                </h4>
                <div className="row">
                    <div className='col-md-4 mb-3'>
                        <label htmlFor='default_rate'>
                            Penalty period (max.  in months)<span className='text-danger'>*</span>
                        </label>
                        <input
                            type='text'
                            className={`form-control ${
                                errors?.penalty_period &&
                                touched?.penalty_period &&
                                "is-invalid"
                            }`}
                            name='penalty_period'
                            id='penalty_period'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='5'
                            value={values.penalty_period}
                        />
                        {errors?.penalty_period && touched?.penalty_period && (
                        <span className='text-danger'>{errors?.penalty_period}</span>
                        )}
                    </div>
                    <div className='col-md-4 mb-3'>
                        <label htmlFor='default_rate'>
                            Penalty Value (%)<span className='text-danger'>*</span>
                        </label>
                        <input
                        type='text'
                        className={`form-control ${
                            errors?.penalty_value &&
                            touched?.penalty_value &&
                            "is-invalid"
                        }`}
                        name='penalty_value'
                        id='penalty_value'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='%'
                        value={values.penalty_value}
                        />
                        {errors?.penalty_value && touched?.penalty_value && (
                        <span className='text-danger'>{errors?.penalty_value}</span>
                        )}
                    </div>
                </div>
                <div className='border p-3 rounded-3 my-4 position-relative' >
                <h4 className='fw-semibold bg-white position-absolute profile-title'>
                    Cool Off
                </h4>
                <div className="row">
                    <div className='col-md-4 mb-3'>
                        <label htmlFor='default_rate'>
                          Cool off period (max.  in days)<span className='text-danger'>*</span>
                        </label>
                        <input
                            type='text'
                            className={`form-control ${
                                errors?.cool_off_period &&
                                touched?.cool_off_period &&
                                "is-invalid"
                            }`}
                            name='cool_off_period'
                            id='cool_off_period'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.cool_off_period}
                            placeholder='5'
                        />
                        {errors?.cool_off_period && touched?.cool_off_period && (
                        <span className='text-danger'>{errors?.cool_off_period}</span>
                        )}
                    </div>
                    <div className='col-md-4 mb-3'>
                        <label htmlFor='default_rate'>
                          Cool off Value (%)<span className='text-danger'>*</span>
                        </label>
                        <input
                        type='text'
                        className={`form-control ${
                            errors?.cool_off_value &&
                            touched?.cool_off_value &&
                            "is-invalid"
                        }`}
                        name='cool_off_value'
                        id='cool_off_value'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='%'
                        value={values.cool_off_value}
                        />
                        {errors?.cool_off_value && touched?.cool_off_value && (
                        <span className='text-danger'>{errors?.cool_off_value}</span>
                        )}
                    </div>
                </div>
            </div>
            </div>
        </div>
      )}
    </>
  );
};

export default Settings;
